// @core/api/endpoints/fiscalization/create_fiscal_receipt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFiscalReceiptRequest,
  CreateFiscalReceiptResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Create fiscal receipt
 * Creates and submits a fiscal receipt to the configured provider. For auto_fiscalize tenants, this is called automatically on payment events.
 */
export async function CreateFiscalReceipt(
  data: CreateFiscalReceiptRequest,
  options?: RequestOptions
): Promise<CreateFiscalReceiptResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-receipts`;
  const requestOptions = options;
  return client.post<CreateFiscalReceiptResponse>(requestPath, data, requestOptions);
}
